import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useGlobalNativeMessage } from '../hooks/useGlobalNativeMessage';

export const GlobalNativeListener: React.FC = () => {
  const navigate = useNavigate();
  useGlobalNativeMessage(navigate);
  return null;
};